export default "__VITE_ASSET__DoL6a8Q___"